<h1 mat-dialog-title style="font-size:16px; font-weight:600; margin-bottom:4px;">
  Submit for Review
</h1>

<div
  mat-dialog-content
  style="font-size:13px; line-height:1.3; word-wrap:break-word; white-space:normal;"
>
  <p style="margin:0 0 4px 0;">
    The application is ready to be submitted.
  </p>
  <p style="margin:0 0 8px 0;">
    Would you like to submit the application?
  </p>

  <mat-checkbox
    [(ngModel)]="isCertified"
    style="display:block; margin-top:6px; font-size:12px; text-align:justify;"
  >
    By checking this box, I certify under penalty of perjury that all information I have provided
    is true and correct to the best of my knowledge.
  </mat-checkbox>
</div>

<div
  mat-dialog-actions
  style="margin-top:10px !important; float:right !important; display:flex; gap:8px;"
>
  <button mat-raised-button (click)="onClickNo()">NO</button>
  <button
    mat-raised-button
    color="accent"
    [disabled]="!isCertified || disableGrantSave"
    (click)="onClickYes()"
  >
    YES
  </button>
</div>
